import { Breakdowns } from "./Breakdowns";
import { BreakdownsProvider } from "./contexts/BreakdownsContext";

export const BreakdownsWrapper = ({isShare, narrative}) => {
  return (
    <BreakdownsProvider isShare={isShare} narrative={narrative}>
      <Breakdowns isShare={isShare} narrative={narrative}/>
    </BreakdownsProvider>
  )
}